import { axiosInstanceNotAuthorized } from './axiosInstance';

export const getWatchedStoriesData = (userId) => axiosInstanceNotAuthorized.get(`stories/watched/?user_id=${userId}`);

export const putWatchedSet = (data) =>
    axiosInstanceNotAuthorized.put(`stories/watched/`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
